/**
 * @typedef {Object} USPData
 * @property {string[]} [results] - Legacy USP data structure
 * @property {string[]} [USP] - New USP data structure
 * @property {string[]} [DISTINCTION] - New distinction data structure
 */

/**
 * Utility function to check if the USP data is in the new format
 * @param {USPData} data - The USP data to check
 * @returns {boolean} - True if the data is in the new format
 */
export function isNewUSPFormat(data) {
  return data && (data.USP !== undefined || data.DISTINCTION !== undefined);
}

/**
 * Utility function to get USP data in a consistent format
 * @param {USPData} data - The USP data to process
 * @returns {Object} - Normalized USP data
 */
export function normalizeUSPData(data) {
  if (!data) return { USP: [], DISTINCTION: [] };

  if (isNewUSPFormat(data)) {
    return {
      USP: data.USP || [],
      DISTINCTION: data.DISTINCTION || []
    };
  }

  // Legacy format
  return {
    USP: data.results || [],
    DISTINCTION: []
  };
}
